import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-paypal-payments',
  templateUrl: './paypal-payments.component.html',
  styleUrls: ['./paypal-payments.component.css']
})
export class PaypalPaymentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
